export default "__VITE_ASSET__zqnnoOYA__"